// src/pages/staff/components/StaffDialogs.tsx
import React from "react";
import AddStaffDialog from "./AddStaffDialog";
import EditStaffDialog from "./EditStaffDialog";
import DeleteStaffDialog from "./DeleteStaffDialog";
import { Staff, StaffFormData } from "src/shared/services/interfacev2";

interface StaffDialogsProps {
  addDialogOpen: boolean;
  editDialogOpen: boolean;
  deleteDialogOpen: boolean;
  selectedStaff: Staff | null;
  deleteStaffName: string;

  onCloseAdd: () => void;
  onCloseEdit: () => void;
  onCloseDelete: () => void;

  onAddStaff: (formData: StaffFormData) => Promise<boolean>;
  onUpdateStaff: (id: string, formData: StaffFormData) => Promise<boolean>;
  onDeleteStaff: (id: string) => Promise<boolean>;
}

const StaffDialogs: React.FC<StaffDialogsProps> = ({
  addDialogOpen,
  editDialogOpen,
  deleteDialogOpen,
  selectedStaff,
  deleteStaffName,
  onCloseAdd,
  onCloseEdit,
  onCloseDelete,
  onAddStaff,
  onUpdateStaff,
  onDeleteStaff,
}) => {
  const handleDelete = async () => {
    if (selectedStaff) {
      return await onDeleteStaff(selectedStaff._id.$oid);
    }
    return false;
  };

  return (
    <>
      {/* Add Staff */}
      <AddStaffDialog
        open={addDialogOpen}
        onClose={onCloseAdd}
        onAddStaff={onAddStaff} 
      />

      {/* Edit Staff */}
      <EditStaffDialog 
        open={editDialogOpen} 
        onClose={onCloseEdit} 
        staff={selectedStaff} 
        onUpdateStaff={onUpdateStaff} 
      />

      {/* Delete Staff */}
      <DeleteStaffDialog
        open={deleteDialogOpen}
        onClose={onCloseDelete}
        staffName={deleteStaffName}
        onDelete={handleDelete}
      />
    </>
  );
};

export default StaffDialogs;